"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _Collapse = _interopRequireDefault(require("../Collapse/Collapse"));
var _constants = require("../constants");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Svg = _interopRequireDefault(require("../Svg/Svg"));
var _currency = require("../../currency");
var _pricing = require("../../helpers/pricing");
var _constants2 = require("./constants");
var _CurrencyDropdown = _interopRequireDefault(require("../CurrencyDropdown/CurrencyDropdown"));
var _newComponents = require("../../new-components");
var _constants3 = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getUniqueActivePackagesForWeek = function getUniqueActivePackagesForWeek(standardYachts) {
  var packagesDataObject = standardYachts.reduce(function (prev, curr) {
    prev[curr["package"].id] = _objectSpread(_objectSpread({}, curr["package"]), {}, {
      hullType: curr.hullType
    });
    return prev;
  }, {});
  return Object.values(packagesDataObject);
};
var WeekList = function WeekList(_ref) {
  var weeks = _ref.weeks,
    context = _ref.context,
    destinationId = _ref.destinationId,
    standardYachts = _ref.standardYachts;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    filteredWeeks = _useState2[0],
    setFilteredWeeks = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    years = _useState4[0],
    setYears = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    selectedYear = _useState6[0],
    setSelectedYear = _useState6[1];
  (0, _react.useEffect)(function () {
    var w = filterInvisibleWeeks(weeks);
    setFilteredWeeks(w);
    setAvailableYears(w);
  }, [destinationId]);
  (0, _react.useEffect)(function () {
    if (selectedYear) {
      var w = filterInvisibleWeeks(weeks);
      setFilteredWeeks(w.filter(function (week) {
        return week.year === selectedYear;
      }));
    }
  }, [selectedYear]);
  var setAvailableYears = function setAvailableYears(weeks) {
    if (!weeks || !weeks.length) {
      return null;
    }
    // combination of getUniqueEntriesFromArray, getUniqueYearsFromWeeks from tyw repo
    var years = Array.from(new Set(Object.values(weeks).map(function (w) {
      return w.year;
    }))).sort(function (a, b) {
      return a - b;
    });
    setYears(years);
    setSelectedYear(years && years[0]);
  };
  var filterInvisibleWeeks = function filterInvisibleWeeks(weeks) {
    var showInvisibleWeeks = [_constants3.TYW_DESTINATION.YACHTNIK_CROATIA, _constants3.TYW_DESTINATION.YACHTNIK_MART_ST_LUCIA, _constants3.TYW_DESTINATION.BVI_HAYWIRE].includes(destinationId);
    var w = showInvisibleWeeks ? weeks : weeks.filter(function (week) {
      return !week.invisible;
    });
    return w;
  };
  var months = [];
  var currencies = filteredWeeks.length && filteredWeeks.every(function (w) {
    return !!w.fixedExchangeRate;
  }) ? [filteredWeeks[0].currency] : _constants.SUPPORTED_CURRENCIES;
  filteredWeeks.forEach(function (week) {
    var month = (0, _moment["default"])(week.beginDate).format("MMM");
    var hasMonth = months.some(function (option) {
      return option.text === month;
    });
    var fromPrices = week.fromPrices,
      status = week.status,
      fixedExchangeRate = week.fixedExchangeRate;
    var packages = getUniqueActivePackagesForWeek(standardYachts);
    var statusText;
    if (status === "sold_out") {
      statusText = "Sold out";
    } else if (status === "coming_soon") {
      statusText = "Coming soon";
    }
    var link = "/browse/category?dest=".concat(destinationId, "&weeks=").concat(week.week, "&year=").concat(week.year);
    var items = packages.map(function (packageData) {
      // 1. check fromPrice from endpoint
      var value = null;
      if (fromPrices[packageData.id]) {
        value = "From ".concat((0, _pricing.formatCurrency)(fromPrices[packageData.id], week.currency, fixedExchangeRate ? week.currency : context.currency, true, context.rates), "pp");
      }
      // 2. check week status
      value = value || statusText;
      // 3. check syw
      var sywText = standardYachts && standardYachts.find(function (sy) {
        return sy["package"].id === packageData.id;
      }) ? "Sold out" : "Unavailable";
      // 4. check cabins availability
      var cabinOpen = ["open", "prebooking"].includes(week.cabinStatus);
      var hasAvailableCabinsForWeekAndCategory = week.available[packageData.id].cabin > 0 || week.available[packageData.id].cabin === null;
      var hasAvailableSolosForWeekAndCategory = week.available[packageData.id].solo > 0 || week.available[packageData.id].solo === null;
      var cabinAvailability = cabinOpen && hasAvailableCabinsForWeekAndCategory && hasAvailableSolosForWeekAndCategory && "Cabins Only";
      if (cabinAvailability && sywText && !value) {
        value = cabinAvailability;
      } else {
        value = value || sywText;
      }
      return {
        "package": packageData,
        value: value
      };
    });
    items.push({
      "package": {
        name: "Custom",
        hullType: "custom"
      },
      value: statusText || "Price varies on selection"
    });
    var isFeatured = Object.keys(_constants2.FEATURED_WEEKS).includes(String(week.id));
    var normalizedWeek = {
      beginDate: (0, _moment["default"])(week.guestBeginDate).format("D"),
      endDate: (0, _moment["default"])(week.guestEndDate).format("D"),
      image: isFeatured && _constants2.FEATURED_WEEKS[week.id].image || _constants2.FEATURED_WEEKS_FALLBACK_IMAGE,
      logo: isFeatured && _constants2.FEATURED_WEEKS[week.id].logo,
      weekName: week.week,
      featured: isFeatured,
      title: week.name,
      weekId: week.id,
      subtitle: "".concat((0, _moment["default"])(week.guestBeginDate).format("Do MMMM"), " - ").concat((0, _moment["default"])(week.guestEndDate).format("Do MMMM")),
      status: status,
      fromPrice: week.fromPrices.general,
      items: items,
      link: {
        url: link,
        disabled: !!statusText,
        text: statusText || "Browse"
      }
    };
    return !hasMonth ? months.push({
      text: month,
      weeks: [normalizedWeek]
    }) : months.map(function (option) {
      return option.text === month && option.weeks.push(normalizedWeek);
    });
  });
  if (!months.length) {
    return null;
  }
  months = months.map(function (month) {
    return _objectSpread(_objectSpread({}, month), {}, {
      price: Math.min.apply(Math, (0, _toConsumableArray2["default"])(month.weeks.map(function (week) {
        return week.fromPrice;
      }).filter(function (week) {
        return !!week;
      })))
    });
  });
  var monthTitle = function monthTitle(month) {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex padding-x-lg padding-y-md "
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: "calendar",
      className: "icon--md margin-right-xs",
      fill: _constants.COLORS.BLACK
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "d8-u-text-bold"
    }, month.text), !!month.price && Number.isFinite(month.price) && /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-sm"
    }, "From ", /*#__PURE__*/_react["default"].createElement(_currency.FormatCurrency, {
      amount: month.price,
      baseCurrency: "EUR"
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "position-absolute padding-sm d8-week-row-button-wrap"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.NO_STYLE
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d8-u-white-bg width-md height-md flex flex-center d8-u-radius-full"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: "full-arrow-right",
      fill: _constants.COLORS.BLACK
    })))));
  };
  var weekTitle = function weekTitle(week) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "padding-x-lg padding-y-md d8-week-row d8-u-min-height-auto"
    }, week.featured && week.image && week.image.url && /*#__PURE__*/_react["default"].createElement("div", {
      className: "d8-week-row-skew-wrapper"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "week",
      className: "d8-week-row-img absolute flex items-center",
      src: week.image.url
    })), /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        zIndex: 1
      },
      className: "relative flex justify-between"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", {
      className: "d8-u-font-size-base d8-u-ls-xs margin-top-xs margin-bottom-xs"
    }, week.subtitle), /*#__PURE__*/_react["default"].createElement("p", {
      className: "text-sm d8-u-color-contrast-medium font-medium"
    }, week.title)), week.logo && week.logo.url && /*#__PURE__*/_react["default"].createElement("img", {
      style: {
        width: 48,
        height: 48,
        objectFit: "contain"
      },
      className: "margin-top-sm margin-left-sm",
      src: week.logo.url,
      alt: week.logo.alt
    })), week.status === "sold_out" && /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-right-xxs margin-top-sm margin-bottom-0@sm flex"
    }, /*#__PURE__*/_react["default"].createElement(_newComponents.Pill, {
      title: "Sold out",
      type: _newComponents.PILL_TYPES.SOLD_OUT,
      iconFlip: true,
      size: _newComponents.PILL_SIZES.SMALL,
      className: "relative"
    })), week.status === "coming_soon" && /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-right-xxs margin-top-sm margin-bottom-0@sm flex"
    }, /*#__PURE__*/_react["default"].createElement(_newComponents.Pill, {
      title: "Coming soon",
      type: _newComponents.PILL_TYPES.COMING_SOON,
      iconFlip: true,
      size: _newComponents.PILL_SIZES.SMALL,
      className: "relative"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "margin-right-xxs margin-top-sm margin-bottom-0@sm flex"
    }, /*#__PURE__*/_react["default"].createElement(_newComponents.FeaturedWeekPill, {
      weekId: week.weekId,
      isWeekPill: true
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "position-absolute padding-sm d8-week-row-button-wrap"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      buttonType: _constants.BUTTON_TYPES.NO_STYLE
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d8-u-white-bg width-md height-md flex flex-center d8-u-radius-full"
    }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
      name: "full-arrow-right",
      fill: _constants.COLORS.BLACK
    })))));
  };
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, years.length > 1 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center margin-bottom-md"
  }, years.map(function (year) {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      key: year,
      text: year,
      buttonType: _constants.BUTTON_TYPES.FILTER,
      active: selectedYear === year,
      onClick: function onClick() {
        return setSelectedYear(year);
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-card d8-u-radius-md overflow-hidden d8-week-list"
  }, months.map(function (month, monthIndex) {
    return /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      key: JSON.stringify(month + monthIndex),
      hideChevron: true,
      noPadding: true,
      className: "relative d8-week-row flex flex-column width-100% week-list ".concat(monthIndex !== 0 && "border-top", " ").concat(monthIndex % 2 === 0 ? "d8-u-white-bg" : "d8-u-contrast-lower-bg"),
      heading: monthTitle(month),
      on: months.length === 1
    }, /*#__PURE__*/_react["default"].createElement("div", null, month.weeks.map(function (week) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: JSON.stringify(week)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "d8-week-row-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
        className: "d8-u-white-bg",
        hideChevron: true,
        noPadding: true,
        heading: weekTitle(week)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "padding-x-lg padding-y-md"
      }, week.items.map(function (item) {
        var _item$package$hullTyp;
        var packageColour = (0, _constants2.getPackageColorVariable)(item["package"].id);
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: JSON.stringify(item),
          className: "flex margin-bottom-sm"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: ""
        }, /*#__PURE__*/_react["default"].createElement("p", {
          className: "d8-u-text-bold",
          style: {
            color: item["package"].hullType === "custom" ? "black" : packageColour
          }
        }, item["package"].name), /*#__PURE__*/_react["default"].createElement("p", {
          className: "text-sm d8-u-color-contrast-high d8-u-font-weight-500"
        }, item.value)), /*#__PURE__*/_react["default"].createElement("div", {
          className: "flex-1 flex items-center justify-end"
        }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
          className: "icon--xl",
          name: "yacht_type_".concat((_item$package$hullTyp = item["package"].hullType) === null || _item$package$hullTyp === void 0 ? void 0 : _item$package$hullTyp.toLowerCase()),
          fill: item["package"].hullType === "custom" ? "black" : packageColour
        })));
      }), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        className: "margin-top-sm",
        text: week.link.text,
        link: week.link.url,
        disabled: week.link.disabled,
        fullWidth: true
      })))));
    })));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md flex justify-end width-100%"
  }, /*#__PURE__*/_react["default"].createElement(_CurrencyDropdown["default"], {
    supportedCurrencies: currencies,
    buttonType: _constants.BUTTON_TYPES.GHOST_BG
  })));
};
WeekList.propTypes = {
  weeks: _propTypes["default"].array,
  context: _propTypes["default"].object,
  destinationId: _propTypes["default"].number.isRequired,
  standardYachts: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = WeekList;